<template>
  <div id="BidApprovedetail">
    <!-- <h3>招标审批</h3> -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <el-row>
      <el-col :span="14">
        <div class="contain">
          <el-form :model="form" label-width="200px">
            <!-- <el-form-item label="申请人" prop="applicant">
              <el-select v-model="form.applicant" placeholder="请选择" class="input">
                <el-option v-for="item in approve" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                class="input"
                v-model="form.tenderee"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="采购文件名称" prop="procurefile">
              <el-input
                class="input"
                v-model="form.procurefile"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="发布途径" prop="publishway">
              <el-input
                class="input"
                v-model="form.publishway"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="发布日期" prop="publishDate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="form.publishDate"
                  type="date"
                  placeholder="请选择日期"
                  disabled
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>

            <el-form-item label="方式" prop="way">
              <el-input
                class="input"
                v-model="form.way"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="tenderType">
              <el-input
                class="input"
                v-model="form.tenderType"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="采购内容" prop="procurecontent">
              <el-input
                class="input"
                v-model="form.procurecontent"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
              <el-select
                v-model="form.applicant"
                placeholder="请选择"
                class="input"
                @change="selectChange()"
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="拟组建的法律服务团队成员" prop="lawTerm">
              <el-select
                v-model="form.lawTerm"
                placeholder="请选择"
                disabled
                class="input"
                multiple
                filterable
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请事项" prop="matter">
              <el-input
                class="input"
                v-model="form.matter"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
            <el-form-item label="申请理由" prop="reason">
              <el-input
                class="input"
                v-model="form.reason"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
            <el-form-item label="投标决策委员会审核意见" prop="opinion">
              <!-- <el-input v-model="form.cuase" class="input" placeholder="请输入"></el-input> -->
              <el-input
                class="input"
                v-model="form.opinion"
                :autosize="{ minRows: 3 }"
                type="textarea"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
            <el-form-item label="投标决策委员会成员" prop="bidDecisionTeam">
              <el-select
                v-model="form.bidDecisionTeam"
                placeholder="请选择"
                class="input"
                multiple
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用章类型" prop="seal.sealType">
              <el-select
                v-model="form.seal.sealType"
                placeholder="请选择"
                class="input"
                disabled
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="二次审批人" prop="applicantS">
              <el-select v-model="form.applicantS" placeholder="请选择" class="input" disabled>
                <el-option v-for="item in approve" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="附件" prop="file" v-if="form.file.length > 0">
              <div v-for="item in form.file" :key="item.id" class="input">
                <div class="fj">
                  <div style="flex: 1">
                    <img
                      src="../../assets/file/word.svg"
                      v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                    />
                    <img
                      src="../../assets/file/xls.svg"
                      v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                    />
                    <img
                      src="../../assets/file/png.svg"
                      v-if="
                        item.ftype == 'jpg' ||
                        item.ftype == 'jpeg' ||
                        item.ftype == 'png'
                      "
                    />
                    <img
                      src="../../assets/file/PDF.svg"
                      v-if="item.ftype == 'pdf'"
                    />
                  </div>
                  <div class="fname" style="flex: 9">
                    <div style="word-break: break-all">
                      {{ item.fname }}
                    </div>
                    <div class="word">
                      <span
                        @click="look(item)"
                        class="look"
                        v-if="
                          $store.state.rolesname.includes(
                            'BidApprovedetail_look'
                          )
                        "
                        >预览</span
                      >
                      <span
                        class="down"
                        @click="down(item)"
                        v-if="
                          $store.state.rolesname.includes(
                            'BidApprovedetail_down'
                          )
                        "
                        >下载</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="right">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in logs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.content }}</div>
                <div class="time">
                  {{ handleFTime(item.timestamp) }}
                </div>
              </div>
              <div style="color: #909399">{{ item.type }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="right" v-if="processlogs.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in processlogs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.type }}</div>

                <div class="time">
                  {{ item.timestamp }}
                </div>
              </div>
              <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="right" v-if="Process.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in Process"
              :key="index"
              :timestamp="item.type"
            >
              {{ item.name }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
    <div class="footer">
      <el-button
        type="primary"
        @click="approval(0)"
        v-if="
          $store.state.rolesname.includes('BidApprove_pass') && dayin != false
        "
        >通过</el-button
      >
      <el-button
        type="warning"
        @click="approval(1)"
        v-if="
          $store.state.rolesname.includes('BidApprove_refuse') && dayin != false
        "
        >驳回</el-button
      >
      <el-button class="history" @click="history">返回</el-button>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div class="refuse">
          <el-button
            @click="refuse('failformref')"
            type="primary"
            v-if="dayin != false"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>

    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
      
<script>
import { TenderDetail, TenderSuccess, TenderReject } from '../../api/examine'
import { user } from '../../api/seal'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import { requestDownLoadFile as downfile } from '../../api/seal'
import mammoth from 'mammoth'
import { CaseLog, CaseProcess, CaseApprover } from '../../api/bankrupt'

// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'BidApprovedetail',
  data() {
    return {
      isLoading: false,
      next: true, //是否是三级菜单,显示二级菜单
      Guid: '',
      dayin: true,
      logs: [],
      form: {
        file: [],
        seal: {}
      },
      Isapproval: false,
      //审核弹出框
      approvaldialog: false,
      title: '',
      failform: {},
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"},
      ], //合同用章
      approve: [], //二次审批人
      // method: [],//方式
      // type: [],//类型
      Lawyer: [], //法律团队成员

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数

      Process: {},
      processlogs: {}
    }
  },

  methods: {
    Successlog() {
      CaseApprover({ TenderId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetUser() {
      user({}).then((res) => {
        //获取所有律师
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.Guid, type: 'tender' }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        }
      })
    },
    //发布日期
    onMouseOver() {
      if (this.form.publishTime != undefined && this.form.publishTime != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    GetData() {
      //获取数据
      TenderDetail({ Id: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.form = res.data.data
          if (this.form.seal == null) {
            this.form.seal = {
              sealId: null,
              sealType: ''
            }
          }
          this.GetProcess()
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    handleRemove(file, fileList) {
      //删除成功触发
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      //删除触发
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeUpload(file) {
      var type = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.wps,.WPS'.indexOf(type) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error('只能上传jpg,jpeg,png,doc,docx,xls,xlsx格式的文件')
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList) {},

    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    // 时间格式
    handleFTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.id }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.id }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.id }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    async down(item) {
      //下载
      this.isLoading = true
      const res = await downfile({
        Id: item.id
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.isLoading = false
        return
      }
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null

      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.fname + '.' + fileType)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    approval(type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')

      if (type == 0) {
        this.isLoading = true
        TenderSuccess({ Id: this.Guid }).then((res) => {
          if (res.data.status == 'success') {
            this.title = ''
            header[0].style.display = 'none'
            this.approvaldialog = true
            this.Isapproval = true
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      }
      if (type == 1) {
        this.title = '驳回原因'
        header[0].style.display = ''
        this.approvaldialog = true
        this.failform.id = this.Guid
      }
    },
    handleCancle() {
      if (this.Isapproval) {
        this.$router.go(-1)
        this.Isapproval = false
      }
    },
    refuse(form) {
      //驳回
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          TenderReject({
            Id: this.failform.id,
            Reason: this.failform.Reason
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.approvaldialog = false
              this.Isapproval = true
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.approvaldialog = false
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    GetProcess() {
      CaseProcess({ TenderId: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.Process = res.data.data
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    }
  },

  created() {
    this.Guid = this.$route.query.guid
    this.dayin = this.$route.query.dayin
    this.getvalue()
    this.GetUser()
    this.GetData()
    this.GetLog()
    this.Successlog()
  },
  computed: {}
}
</script>
      
<style lang="less" scoped>
#BidApprovedetail .contain {
  width: 90%;
  margin: auto;
}

#BidApprovedetail .right {
  width: 80%;
  margin: auto;
  margin-top: 3.125rem;
}

#BidApprovedetail .input {
  width: 50%;
}

#BidApprovedetail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#BidApprovedetail .fjimg {
  width: 16%;
  margin-bottom: 10px;
}

#BidApprovedetail .input img {
  width: 100%;
  height: 100%;
}

#BidApprovedetail .fname {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#BidApprovedetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#BidApprovedetail .look {
  color: #fe964a;
  margin-right: 10px;
}

#BidApprovedetail .down {
  color: #2bc887;
}

#BidApprovedetail .word {
  line-height: 18px;
  cursor: default;
}

// 底部按钮
#BidApprovedetail .footer {
  width: 100%;
  margin: auto;
  text-align: center;
}

#BidApprovedetail .history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

#BidApprovedetail .btnfail {
  border: 1px solid #3077e6;
  color: #3077e6;
}

// 弹出框
#BidApprovedetail /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#BidApprovedetail .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#BidApprovedetail .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#BidApprovedetail .fail {
  width: 100%;
}

#BidApprovedetail .refuse {
  width: 100%;
  text-align: center;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

#BidApprovedetail .date_box {
  width: 50%;

  .el-icon-date {
    position: absolute;
    top: 50%;
    right: calc(50% + 10px);
    z-index: 9;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}
</style>
      